export default class CampaignAddController {

    constructor($state, $stateParams, $ionicPopup, $ionicHistory, ApiCampaigns, ApiPicklist, $ionicLoading, MessageBox, DATE_FORMAT, $rootScope) {
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$ionicHistory = $ionicHistory;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiPicklist = ApiPicklist;
        this.MessageBox = MessageBox;
        this.DATE_FORMAT = DATE_FORMAT;
        this.loading = [];
        this.campaignStati = {
            'ONGOING': 'STATUS_ONGOING',
            'CLOSED': 'STATUS_CLOSED'
        };
        this.$rootScope = $rootScope;
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
        this.data = {}; // encapsulated data model
        this.data.campaign = {};
        this.data.hideList = false;
        this.campaignTitle = {};
        this.regions = [];

        if (this.isEdit()) {
            this.$rootScope.pageTitle = 'EDIT_CAMPAIGN';
            let campaignId = this.$stateParams.campaignId;
            this.getCampaign(campaignId);
            this.hasParentCampaign(campaignId);
        } else {
            this.$rootScope.pageTitle = 'CREATE_CAMPAIGN';
            this.data.campaign = this.createEmptyCampaign();
        }

        this.getYears();
        this.getCurrencies();
        this.getCountries();

        this.cleaveNumeral = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand'
        }
    }

    createEmptyCampaign() {
        return {
            adHoc: false,
            dueDate: this.DATE_FORMAT,
            startDate: new Date(),
            status: 'ONGOING'
        }
    }

    getCurrencies() {
        this.showLoading();
        this.ApiCampaigns.retrieveCurrencyList().then((currency) => {
            this.currencyValues = currency.data;
            this.hideLoading();
        }, function (error) {
            this.hideLoading();
        });
    }

    getCountries() {
        this.showLoading();
        this.ApiPicklist.getAdvindaCountries().then((countries) => {
            this.regions = countries.data.sort();
            this.hideLoading();
        }, function (error) {
            this.hideLoading();
        });
    }

    getYears() {
        this.yearValues = this.ApiCampaigns.createPicker(new Date().getFullYear(), 10);
    }

    getCampaign(campaignId) {
        this.showLoading();
        this.ApiCampaigns.getCampaign(campaignId).then((campaign) => {
            this.data.campaign = campaign || {};
            this.hideLoading();
        }, function (error) {
            this.hideLoading();
        });
    }

    isEdit() {
        this.editMode = !!this.$stateParams.campaignId;
        return this.editMode;
    }

    // Iterate through each contact object to set a hidden flag if the
    // contact is already saved for the campaign
    // This is needed because the contact cannot be removed from the database
    // when user uncheck the contact
    HideCheckedContacts() {
        var self = this;
        this.contacts.map(function (c) {
            c.hide = self.data.contacts.some(function (e) {
                return false;
            });
        });
    }

    saveCampaign() {
        if (this.isEdit())
            this.editCampaign();
        else
            this.insertCampaign();
    }

    insertCampaign() {
        this.showLoading();
        let data = this.formatData();
        this.ApiCampaigns.postCampaign(data).then((res) => {
            this.hideLoading();
            if (angular.isUndefined(res)) return;

            this.$state.go('campaignDetail', {
                campaignId: res.campaignId
            }, {
                reload: true
            });
        });
    }

    editCampaign() {
        this.showLoading();
        let data = this.formatData();
        var campaign = {};
        campaign.campaign = data.campaign;
        this.ApiCampaigns.putCampaign(campaign).then((campaign) => {
            this.hideLoading();

            this.$state.go('campaignDetail', {
                campaignId: campaign.campaignId
            }, {
                reload: true
            });
        });
    }


    showLoading() {
        this.loading.push(1);
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
    }

    hideLoading() {
        this.loading.pop();
        if (this.loading.length === 0)
            this.$ionicLoading.hide();
    }

    formatData() {
        if (this.editMode) {
            this.data.campaign.campaignTitle = this.data.campaign.campaignTitle;
        } else {
            let fundmanager = this.campaignTitle.fundmanager;
            let fund = this.campaignTitle.fund;
            let year = this.data.campaign.startDate.getFullYear();
            let region = this.campaignTitle.region;
            this.data.campaign.campaignTitle = fundmanager + ' - ' + fund + ' - ' + year + ' - ' + region;
        }

        let data = JSON.parse(JSON.stringify(this.data));
        delete data.isCheckedItemsHidden;
        delete data.hideList;
        if (data.campaign.status) data.campaign.status = data.campaign.status.toUpperCase();
        if (data.campaign.targetInvestment == '') data.campaign.targetInvestment = 0;

        data.campaign.parent = (this.$stateParams.type == 'mother' || data.campaign.parent);
        return data;
    }

    isStartDateAfterDueDate() {
        if (this.data && this.data.campaign) {
            let startDate = this.data.campaign.startDate;
            let dueDate = this.data.campaign.dueDate;
            return startDate > dueDate;
        }
    }

    checkDateFormats() {
        let dateInvalid = false;
        if (this.data.campaign.startDate === this.DATE_FORMAT) {
            dateInvalid = true;
            this.startDate_required = true;
        } else {
            this.startDate_required = false;
        }

        if (this.data.campaign.dueDate === this.DATE_FORMAT) {
            dateInvalid = true;
            this.dueDate_required = true;
        } else {
            this.dueDate_required = false;
        }

        return dateInvalid;
    }

    onDateChange(date) {
        if (date === 'startDate') {
            this.startDate_required = false;
        } else if (date === 'dueDate') {
            this.dueDate_required = false;
        }
    }

    redirectToMotherCreatePage() {
        this.redirectWithoutAnimation();
        this.$state.go('motherCampaignAdd');
    }

    redirectToChildCreatePage() {
        this.redirectWithoutAnimation();
        this.$state.go('campaignAdd', {
            type: 'children'
        });
    }


    redirectWithoutAnimation() {
        this.$ionicHistory.nextViewOptions({
            disableAnimate: true
        });
    }

    hasParentCampaign(campaignId) {
        this.ApiCampaigns.hasParentCampaign(campaignId).then((response) => {
            if (response) {
                this.hasParent = true;
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaignAdd.controller.js
 **/